<template>
    <label class="mt-10 h3">{{ model.formsText }}</label>
</template>

<script lang="ts" setup>
import { FormsTextBlock } from '@/api/content/models/forms-text-block';

type Props = {
    model: FormsTextBlock;
}

defineProps<Props>();
</script>